import { useEffect, useState } from "react";
import { useSiteClub } from "../lib/SiteClubContext";
import { listLocations, type LocationRow } from "../lib/api";
import { LocationCard } from "../components/LocationCard";

export default function HobbyShopsPage() {
  const [locations, setLocations] = useState<LocationRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { club, loading: clubLoading } = useSiteClub();

  // On a club's own site, only that club's hobby shops.
  useEffect(() => {
    if (clubLoading) return;
    listLocations("hobby_shop", club?.clubId)
      .then((res) => setLocations(res.locations))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load hobby shops."));
  }, [club?.clubId, clubLoading]);

  return (
    <div>
      <h1>Hobby shops</h1>
      {error && <p className="err">{error}</p>}
      {!locations && !error && <p className="muted">Loading…</p>}
      {locations && locations.length === 0 && <p className="muted">No hobby shops listed yet.</p>}
      <div className="events-grid">
        {locations?.map((l) => (
          <LocationCard key={l.locationId} location={l} />
        ))}
      </div>
    </div>
  );
}
